import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { FaEllipsisV } from 'react-icons/fa';

const PaymentList = () => {
    const payments = [
        { id: 'AD01274300378CIN', date: '21.06.25', package: 'YouTube Insta TikTok Videos', price: '€54.99', details: 'Basic Cut and audio', duration: '5 minutes' },
        { id: 'AD01274300378CIN', date: '21.06.25', package: 'YouTube Insta TikTok Videos', price: '€54.99', details: 'Basic Cut and audio', duration: '5 minutes' },
        { id: 'AD01274300378CIN', date: '21.06.25', package: 'YouTube Insta TikTok Videos', price: '€54.99', details: 'Basic Cut and audio', duration: '5 minutes' }
    ];

    return (
        <div className="payment-list">
            {payments.map((payment, index) => (
                <div key={index} className="payment-item">
                    <div className="payment-info">
                        <div><strong>Order Id : </strong>{payment.id}</div>
                        <div><strong>Invoice : </strong>{payment.date}</div>
                        <div>{payment.package}</div>
                        <div>{payment.details}</div>
                        <div>{payment.duration}</div>
                    </div>
                    <div className="payment-action">

                        <div className="payment-actions">
                            <Dropdown align="end">
                                <Dropdown.Toggle variant="link" id="dropdown-custom-components">
                                    <FaEllipsisV />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item>View PDF</Dropdown.Item>
                                    <Dropdown.Item>Download PDF</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div className="payment-price">
                            <span>{payment.price}</span>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PaymentList;
